export default __webpack_public_path__ + "static/media/SPPL_Fiscal_2022.f3f943ed.pdf";